import { LabelKeyPrefixes, LabelKeyTemplates } from '@yme/types/index';
import { getProductURL } from '@yme/utils/product';
import { GET_DESTINATIONS_FOR_SLUG_ENDPOINT, ROOT_PATH_PREFIX, SLUG_PREFIX } from './constants';
export function isUnitRelatedExperienceEmpty() {
    return true;
}
export const buildRequestUrl = (slug, rootPath) => GET_DESTINATIONS_FOR_SLUG_ENDPOINT.replace(SLUG_PREFIX, slug).replace(ROOT_PATH_PREFIX, rootPath);
export const getDataForDestinationCard = ({ primaryImage, expTitle, currencyCode, expPrice, expLocation, expType, expDuration, expDistance, expLevel, partnerReference, vehicleRental, units, expDateRanges, _path, }, language, edpURL, isInAuthor, unitNames, isDurationAndKmExist) => {
    const slug = _path.split('/').at(-1);
    const updatedUnits = unitNames
        ? units &&
            units.map((unit) => unitNames.products.find((product) => product.slug === unit)?.name || unit)
        : units;
    const expLabels = Array.isArray(expLevel) ? expLevel : [expLevel];
    return {
        image: {
            src: primaryImage?._path ?? '',
            alt: expTitle,
        },
        title: expTitle,
        currencyCode,
        price: expPrice,
        location: expLocation.join(', '),
        typeLabel: expType
            .map((l) => LabelKeyTemplates.TYPE.replace(LabelKeyPrefixes.TYPE, l))
            .join(', '),
        typeLabelEn: expType.join(', '),
        levelLabel: expLabels.map((l) => LabelKeyTemplates.LEVEL.replace(LabelKeyPrefixes.LEVEL, l)),
        levelLabelEn: expLabels,
        partnerReference,
        vehicleRental: LabelKeyTemplates.RENTAL.replace(LabelKeyPrefixes.RENTAL, vehicleRental),
        vehicleRentalEn: vehicleRental,
        units: updatedUnits,
        expDateRanges,
        ...(isDurationAndKmExist && {
            expDuration,
            expDistance,
        }),
        language,
        edpURL: getProductURL({
            path: edpURL,
            isInAuthor,
            slug,
        }),
    };
};
